export default __webpack_public_path__ + "static/media/vision.596080ec.png";